import { FC } from "react";

import { ChatIcon, SearchIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

import ChatHistoryList from "./ChatHistoryList";
import {
  AGENTIC_AI_HEADER_PADDING_Y,
  AGENTIC_AI_SIDEBAR_TITLE,
  type ChatHistoryEntry,
  type ChatListLoadMore
} from "./constants";
import SidebarToggle from "./SidebarToggle";

type Props = {
  chats: ChatHistoryEntry[];
  activeChatId: string | null;
  onNewChat: () => void;
  onSelectChat: (chatId: string) => void;
  onCollapse: () => void;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  loadMore?: ChatListLoadMore;
  isSearchOpen: boolean;
  onToggleSearch: () => void;
};

const actionClassName =
  "flex w-full items-center gap-3 rounded-md text-base px-2 py-2 text-txtBody font-semibold transition-colors hover:bg-teal-50 [&>svg]:h-5 [&>svg]:w-5 [&>svg]:shrink-0 [&>svg]:fill-dim-gray";

const AgenticAISidebar: FC<Props> = ({
  chats,
  activeChatId,
  onNewChat,
  onSelectChat,
  onCollapse,
  isLoading,
  isError,
  onRetry,
  loadMore,
  isSearchOpen,
  onToggleSearch
}) => (
  <aside
    aria-label="Chat history"
    className="flex h-full w-[280px] shrink-0 flex-col border-r border-gainsboro bg-white"
  >
    <div
      className={`flex items-center justify-between gap-2 px-4 ${AGENTIC_AI_HEADER_PADDING_Y}`}
    >
      <h2 className="truncate text-lg font-bold text-txtHeading">
        {AGENTIC_AI_SIDEBAR_TITLE}
      </h2>
      <SidebarToggle isSidebarOpen onToggle={onCollapse} />
    </div>

    <div className="flex flex-col gap-1 px-2 py-3 gap-4 mb-3">
      <button type="button" onClick={onNewChat} className={actionClassName}>
        <ChatIcon />
        New Chat
      </button>

      <button
        type="button"
        onClick={onToggleSearch}
        aria-pressed={isSearchOpen}
        className={twMerge(actionClassName, isSearchOpen && "bg-teal-50")}
      >
        <SearchIcon />
        Search
      </button>
    </div>

    <ChatHistoryList
      chats={chats}
      activeChatId={activeChatId}
      onSelect={onSelectChat}
      isLoading={isLoading}
      isError={isError}
      onRetry={onRetry}
      loadMore={loadMore}
    />
  </aside>
);

export default AgenticAISidebar;
